export const getSlidesConfig = (t) => [
  // Slide 1: Wheat Banner
  {
    id: 2,
    imageUrl: "/images/wheatBanner.webp",
    imageMUrl: "/images/wheatBannerM.webp",
    overlay: "bg-gradient-to-b from-black/10 to-transparent",
    content: {
      title: t("slider.slide2.title"),
      titleStyle:
        "md:font-[lighter] tracking-[0.12em] font-thin font-raleway text-[#983B50] md:text-[1.3em]",
      subtitle: t("slider.slide2.subtitle"),
      subtitleStyle:
        "text-[#B36C5E] [-webkit-text-stroke:0.3px_#000] [paint-order:stroke_fill] md:!mt-3 md:!leading-[33px] md:text-2xl !leading-[26px] md:text-base md:font-bold font-medium tracking-[0.12em] font-raleway",
      buttonText: t("slider.slide2.button"),
      buttonLink: "/wheatbag", // Link to the Wheat Bag page
      buttonStyle:
        "border-[#af7b7b] border-[0.01em] items-center font-[lighter] flex text-white tracking-[0.1em] text-[0.9em] bg-[#af7b7b] font-mukta hover:bg-gray-100 md:h-9 h-[30px] px-2 md:mt-0 mt-[0.5em]",
    },
    layout: {
      type: "bottom-center",
      padding: "md:!pr-20 md:pb-20 pb-[58%] pr-0",
      spacing: "md:space-y-2 space-y-1",
    },
  },
  // Slide 2: Fridge Banner
  {
    id: 1,
    imageUrl: "/images/fridgeBanner.webp",
    imageMUrl: "/images/fridgeBannerM.webp",
    overlay: "bg-black/15 md:bg-black/10",
    content: {
      title: t("slider.slide1.title"),
      titleStyle:
        "md:font-[lighter] tracking-[0.12em] font-thin font-raleway text-[#F7EB9B] md:text-[1.3em]",
      subtitle: t("slider.slide1.subtitle"),
      subtitleStyle:
        "[-webkit-text-stroke:0.3px_#000] [paint-order:stroke_fill] md:!mt-3 md:!leading-[33px] md:text-2xl !leading-[26px] md:text-base md:font-bold font-medium tracking-[0.12em] font-raleway text-white",
      buttonText: t("slider.slide1.button"),
      buttonLink: "/fridgeDeo",
      subtitleImage: "/images/fridgeIcon.png",
      buttonStyle:
        "items-center font-[lighter] flex text-[#7F7F7F] tracking-[0.1em] md:h-9 h-[30px] text-[0.8em] bg-white font-mukta hover:bg-gray-100 px-6 py-2",
    },
    layout: {
      type: "center-left",
      padding: "pl-[16%] md:pb-0 pb-96",
      spacing: "md:space-y-2 space-y-1",
    },
  },
  // Slide 3: Gift Banner
  {
    id: 3,
    imageUrl: "/images/giftBanner.webp",
    imageMUrl: "/images/giftBannerM.webp",
    overlay: "bg-gradient-to-b from-black/10 to-transparent",
    content: {
      title: t("slider.slide3.title"),
      titleStyle:
        "md:font-[lighter] tracking-[0.12em] font-thin font-raleway text-[#983B50] md:text-[1.3em]",
      subtitle: t("slider.slide3.subtitle"),
      subtitleStyle:
        "text-[#a76255] [-webkit-text-stroke:0.3px_#000] [paint-order:stroke_fill] md:!mt-3 md:!leading-[33px] md:text-2xl  !leading-[26px] md:text-base md:font-bold font-medium tracking-[0.12em] font-raleway ",
      buttonText: t("slider.slide3.button"),
      buttonLink: "/giftProducts", // Link to the Wheat Bag page
      buttonStyle:
        "border-[#B36C5E] border-[0.001em] items-center font-[lighter] flex text-[#B36C5E] tracking-[0.1em] text-[0.9em] bg-white font-mukta hover:bg-gray-100 md:px-2 px-3 md:h-9 h-[30px] md:mt-0 mt-[1em]",
    },
    layout: {
      type: "center-right-mobile",
      padding: "md:pl-[60%] md:pb-0 pb-[90%]",
      spacing: "md:space-y-4 space-y-2", // Controls gap between elements
    },
  },
  // Slide 4: Kitchen Banner
  {
    id: 4,
    imageUrl: "/images/kitchenBanner.webp",
    imageMUrl: "/images/kitchenBannerM.webp",
    overlay: "bg-gradient-to-b from-black/10 to-transparent",
    content: {
      title: t("slider.slide4.title"),
      titleStyle:
        "md:font-[lighter] tracking-[0.12em] font-thin font-raleway text-[#676b64] md:text-[1.3em]",
      subtitle: t("slider.slide4.subtitle"),
      subtitleStyle:
        "text-white [-webkit-text-stroke:0.3px_#000] [paint-order:stroke_fill] md:!mt-3 md:!leading-[33px] md:text-2xl  !leading-[26px] md:text-base md:font-bold font-medium tracking-[0.12em] font-raleway text-white",
      buttonText: t("slider.slide4.button"),
      buttonLink: "/kitchenProducts", // Link to the Wheat Bag page
      buttonStyle:
        "items-center font-[lighter] flex text-white tracking-[0.1em] text-[0.9em] bg-[#7F8536] font-mukta hover:bg-[#7F8536]-100 md:px-2 px-3 md:h-9 h-[30px] md:mt-0 mt-[0.5em]",
    },
    layout: {
      type: "center-right",
      padding: "md:pl-[55%] pl-[33%] md:pb-[15%] pb-[90%]",
      spacing: "space-y-2", // Controls gap between elements
    },
  },
  // Slide 5: Japan Banner
  {
    id: 5,
    imageUrl: "/images/japanBanner.webp",
    imageMUrl: "/images/japanBannerM.webp",
    overlay: "bg-gradient-to-b from-black/10 to-transparent",
    content: {
      title: t("slider.slide5.title"),
      titleStyle:
        "md:font-[lighter] tracking-[0.12em] font-thin font-raleway text-[#574F4F] md:text-[1.3em]",
      subtitle: t("slider.slide5.subtitle"),
      subtitleStyle:
        "text-[#5D5A5A] [-webkit-text-stroke:0.3px_#000] [paint-order:stroke_fill] md:!mt-3 md:!leading-[33px] md:text-2xl  !leading-[26px] md:text-base md:font-bold font-medium tracking-[0.12em] font-raleway ",
      buttonText: t("slider.slide5.button"),
      buttonLink: "/japaneseProducts", // Link to the Wheat Bag page
      buttonStyle:
        "items-center font-[lighter] flex text-white tracking-[0.1em] text-[0.9em] bg-[#A92827] font-mukta hover:bg-black-100 md:px-2 px-3 md:h-9 h-[30px] md:mt-0 mt-[0.5em]",
    },
    layout: {
      type: "top-left",
      padding: "md:pl-[29%] pl-[10%] md:pt-[8%] pt-[44%]",
      spacing: "space-y-2", // Controls gap between elements
    },
  },
  // Slide 6: HM Banner
  {
    id: 6,
    imageUrl: "/images/hmBanner.webp",
    imageMUrl: "/images/hmBannerM.webp",
    overlay: "bg-gradient-to-b from-black/10 to-transparent",
    content: {
      title: t("slider.slide6.title"),
      titleStyle:
        "md:font-[lighter] tracking-[0.12em] font-thin font-raleway text-[#512961] md:text-[1.3em]",
      subtitle: t("slider.slide6.subtitle"),
      subtitleStyle:
        "text-white text-right [-webkit-text-stroke:0.3px_#000] [paint-order:stroke_fill] md:!mt-3 md:!leading-[33px] md:text-2xl  !leading-[26px] md:text-base md:font-bold font-medium tracking-[0.12em] font-raleway  text-white",
      buttonText: t("slider.slide6.button"),
      buttonLink: "/handmadeProducts", // Link to the Wheat Bag page
      buttonStyle:
        "items-center font-[lighter] flex text-white tracking-[0.1em] text-[0.9em] bg-[#5D3F69] font-mukta hover:bg-black-100 md:px-2 px-3 md:h-9 h-[30px] md:mt-0 mt-[0.5em]",
    },
    layout: {
      type: "bottom-right",
      padding: "md:pr-[5%] pr-[9%] md:pb-[3%] pb-[20%]",
      spacing: "space-y-2",
    },
  },
  // Slide 7: Canvas Banner
  {
    id: 7,
    imageUrl: "/images/canvasBanner.webp",
    imageMUrl: "/images/canvasBannerM.webp",
    overlay: "bg-gradient-to-b from-black/10 to-transparent",
    content: {
      title: t("slider.slide7.title"),
      titleStyle:
        "md:font-[lighter] tracking-[0.12em] font-thin font-raleway text-[#E5C2C2] md:text-[1.3em]",
      subtitle: t("slider.slide7.subtitle"),
      subtitleStyle:
        "text-white md:text-right text-left [-webkit-text-stroke:0.3px_#000] [paint-order:stroke_fill] md:!mt-3 md:!leading-[33px] md:text-2xl  !leading-[26px] md:text-base md:font-bold font-medium tracking-[0.12em] font-raleway  text-white",
      buttonText: t("slider.slide7.button"),
      buttonLink: "/wallarts", // Link to the Wheat Bag page
      buttonStyle:
        "items-center font-[lighter] flex text-white tracking-[0.1em] text-[0.9em] bg-[#A61D1D] font-mukta hover:bg-black-100 md:px-2 px-3 md:h-9 h-[30px] md:mt-0 mt-[0.5em]",
    },
    layout: {
      type: "bottom-right-mobile",
      padding: "md:pr-[38%] md:pb-[8%] pb-[20%] md:pl-0 pl-[25px]",
      spacing: "space-y-2",
    },
  },
];
